

























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import {
  PensionListAllMap,
  PensionDemands,
  PensionSuppliesItem,
  InvestSupplySummaries,
  InvestSupply,
  EntryAllCfg
} from '@/types/newPersion'

import { pensionListAll } from '@/api/newPersion'
import { CommonMudule } from '@/store/modules/common'
import { PersionModule } from '@/store/modules/pension'
import { tableHead, supplyEnum } from '@/views/newPension/homeCard/utils'

import InsideBarChart from '@/components/g2Charts/chartList/insideBarChart'
import TsTable from '@/components/TsTable/TsTable.vue'
import EmptyTable from '@/components/emptyTable/index.vue'
@Component({
  components: {
    TsTable,
    EmptyTable,
    InsideBarChart,
  },
})
export default class TopChartAndTablePage extends Vue {
  @Prop() entryAllCfg!: EntryAllCfg;
  updateFlag = false
  tableData: {
    data: {
      name: string;
      total: string;
      discounted: string
    }[]
  } = {
    data: [],
  };

  tableHead = tableHead;
  tableAge = 0;
  adjust = [
    { type: 'dodge', dodgeBy: 'analyType', marginRatio: -0.9999 },
    { type: 'stack' },
  ];

  chartOptions = {
    position: [],
    legendPosition: 'top',
    titleNextContent: '岁',
    stackContent: '',
    valueNextContent: '(元/年)',
    barSize: 't1',
    yAxisHide: true,
  };

  chartData: { analyType: string; x: string; y: number; type: string }[] = [];

  @Watch('entryAllCfg', { deep: true })
  handleEntryAllCfg (newEntryAllCfg: EntryAllCfg) {
    if (!this.updateFlag) {
      for (let i = 0; i < newEntryAllCfg.homeCardList.length; i++) {
        const homeCard = newEntryAllCfg.homeCardList[i]
        if (homeCard.status) {
          this.getData()
          this.updateFlag = true
          break
        }
      }
    }
  }

  getPaneValue () {
    return PersionModule.paneValue
  }

  async getData () {
    this.chartData = []
    const res = await pensionListAll({ customerId: CommonMudule.customerId })

    if (res.data) {
      this.handleTable(res.data)
      this.handleChart(res.data)
    }
  }

  handleTable (_data: PensionListAllMap) {
    console.log(_data)
    let _tableAge = 0
    if (_data.investSupplySummaries.length) {
      _tableAge = _data.investSupplySummaries[0].investSupply[0].age
    }
    if (_data.pensionDemands.length) {
      if (_tableAge === 0) {
        _tableAge = _data.pensionDemands[0].age
      }
    }
    if (_data.pensionSupplies.length) {
      if (_tableAge === 0) {
        _tableAge = _data.pensionSupplies[0].age
      }
    }
    this.tableAge = _tableAge
    const _table = [
      {
        name: '总计需求',
        total: _data.totalDemand,
        discounted: _data.discountedDemand,
      },
      {
        name: '总计储备',
        total: _data.totalSupply,
        discounted: _data.discountedSupply,
      },
      {
        name: '产品补充',
        total: _data.totalInvest,
        discounted: _data.discountedInvest,
      },
      {
        name: '剩余缺口',
        total: _data.totalGap,
        discounted: _data.discountedGap,
      },
      {
        name: '满足率',
        total: '-',
        discounted: _data.rate
          ? +(Number(_data.rate) * 100).toFixed(2) + '%'
          : '-',
      },
    ]
    this.tableData.data = _table
  }

  handleChart (_data: PensionListAllMap) {
    const arr: { analyType: string; x: string; y: number; type: string }[] = []
    // 需求
    if (_data?.pensionDemands?.length) {
      const _pensionDemands = _data?.pensionDemands
      _pensionDemands.forEach((w: PensionDemands) => {
        arr.push({
          analyType: 't1',
          x: w.age + '',
          y: +(w.demandAmount / 10000).toFixed(2),
          type: '当年养老金需求（万元）',
        })
      })
    }

    // 供给
    if (_data?.pensionSupplies?.length) {
      const _pensionSupplies = _data?.pensionSupplies
      _pensionSupplies.forEach((w: PensionSuppliesItem) => {
        for (const k in w) {
          if (k !== 'age' && supplyEnum[k] && w[k]) {
            arr.push({
              analyType: 't2',
              x: w.age + '',
              y: +(w[k] / 10000).toFixed(2),
              type: supplyEnum[k] + '（万元）',
            })
          }
        }
      })
    }
    // 保险产品
    if (_data?.investSupplySummaries?.length) {
      const _investSupplySummaries = _data?.investSupplySummaries
      _investSupplySummaries.forEach((w: InvestSupplySummaries) => {
        const _type = w.investName
        w.investSupply.forEach((v: InvestSupply) => {
          arr.push({
            analyType: 't2',
            x: v.age + '',
            y: +(v.amount / 10000).toFixed(2),
            type: _type + '（万元）',
          })
        })
      })
    }
    this.chartData = arr
  }
}
